import { Routes } from '@angular/router';
import { LoginComponent } from './components/auth/login/login.component';
import { PasswordForgottenComponent } from './components/auth/password-forgotten/password-forgotten.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { MainComponent } from './components/main/main.component';
import { MailSearchComponent } from './components/main/mail-search/mail-search.component';
import { authGuard } from './guards/auth.guard';
import { dashboardGuard } from './guards/dashboard.guard';
import { adminGuard } from './guards/admin.guard';
import { AdminUsersComponent } from './components/main/admin/admin-users/admin-users.component';
import { AdminMailAccountsComponent } from './components/main/admin/admin-mail-accounts/admin-mail-accounts.component';
import { AdminSettingsComponent } from './components/main/admin/admin-settings/admin-settings.component';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [authGuard],
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'password-forgotten',
        component: PasswordForgottenComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
      },
      {
        path: '**',
        redirectTo: 'login',
      },
    ],
  },
  {
    path: '',
    canActivate: [dashboardGuard],
    component: MainComponent,
    children: [
      {
        path: '',
        redirectTo: 'search',
        pathMatch: 'full',
      },
      {
        path: 'search',
        component: MailSearchComponent,
      },
      {
        path: 'admin/users',
        canActivate: [adminGuard],
        component: AdminUsersComponent,
      },
      {
        path: 'admin/mail-accounts',
        canActivate: [adminGuard],
        component: AdminMailAccountsComponent,
      },
      {
        path: 'admin/settings',
        canActivate: [adminGuard],
        component: AdminSettingsComponent,
      },
      {
        path: '**',
        redirectTo: 'search',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'auth',
  },
];
